<div *ngIf="showSetting">
    <h5>Menu Type</h5>
    <div class="p-d-flex">
        <div class="p-field-radiobutton p-mr-3">
            <p-radioButton name="menuMode" value="static" [(ngModel)]="app.currentUser.menuMode" inputId="mode1"></p-radioButton>
            <label for="mode1">Static</label>
        </div>
        <div class="p-field-radiobutton p-mr-3">
            <p-radioButton name="menuMode" value="overlay" [(ngModel)]="app.currentUser.menuMode" inputId="mode2"></p-radioButton>
            <label for="mode2">Overlay</label>
        </div>
        <div class="p-field-radiobutton p-mr-3">
            <p-radioButton name="menuMode" value="popup" [(ngModel)]="app.currentUser.menuMode" inputId="mode3"></p-radioButton>
            <label for="mode3">Popup</label>
        </div>
        <div class="p-field-radiobutton p-mr-3">
            <p-radioButton name="menuMode" value="horizontal" [(ngModel)]="app.currentUser.menuMode" inputId="mode4"></p-radioButton>
            <label for="mode4">Horizontal</label>
        </div>
    </div>

    <hr />
    <h5>Landing Page</h5>
    <div class="p-d-flex">
        <div class="p-field-radiobutton p-mr-3">
            <p-dropdown [options]="permittedModuleNames" [(ngModel)]="selectedModulePath" optionLabel="moduleName" optionValue="modulePath" placeholder="Select preferred page..." [filter]="true" [filterBy]="'moduleName'" appendTo="body">
            </p-dropdown>
        </div>
    </div>
    <hr />
    <h5>Input Style</h5>
    <div class="p-d-flex">
        <div class="p-field-radiobutton p-mr-3">
            <p-radioButton name="inputStyle" value="outlined" [(ngModel)]="app.currentUser.inputStyle" inputId="inputStyle1"></p-radioButton>
            <label for="inputStyle1">Outlined</label>
        </div>
        <div class="p-field-radiobutton p-mr-3">
            <p-radioButton name="inputStyle" value="filled" [(ngModel)]="app.currentUser.inputStyle" inputId="inputStyle2"></p-radioButton>
            <label for="inputStyle2">Filled</label>
        </div>
    </div>
    <!-- <hr /> -->
    <!-- <h5>Ripple Effect</h5>
    <p-inputSwitch [ngModel]="app.currentUser.ripple" (onChange)="app.onRippleChange($event)"></p-inputSwitch> -->
    <hr />
    <h5>Flat Layout Colors</h5>
    <div class="layout-themes">
        <div *ngFor="let f of flatLayouts">
            <a style="cursor: pointer" title="{{f.name}}" (click)="changeLayout(f.name)" [ngStyle]="{'background-color': f.color}">
                <i class="pi pi-check" *ngIf="app.currentUser.layout === f.name"></i>
            </a>
        </div>
    </div>

    <hr />

    <h5>Special Layout Colors</h5>
    <div class="layout-themes">
        <div *ngFor="let s of specialLayouts">
            <a style="cursor: pointer" title="{{s.name}}" (click)="changeLayout(s.name)"
               [ngStyle]="{'background-image': 'linear-gradient(to right, ' + s.color1 +','+ s.color2+')'} ">
                <i class="pi pi-check" *ngIf="app.currentUser.layout === s.name"></i>
            </a>
        </div>
    </div>

    <hr />

    <h5>Themes</h5>
    <div class="layout-themes">
        <div *ngFor="let t of themes">
            <a style="cursor: pointer" title="{{t.name}}" (click)="changeTheme(t.name)" [ngStyle]="{'background-color': t.color}">
                <i class="pi pi-check" *ngIf="app.currentUser.theme === t.name"></i>
            </a>
        </div>
        <button class="p-button p-button-label p-mt-3 save-button" style="margin-left: 50rem;" (click)="saveSettings()">Save</button>
        <button class="p-button p-button-label p-mt-3 save-button" style="margin-left: 2rem;" (click)="resetSettings()">Reset</button>
    </div>
</div>

<p-toast position="top-right"></p-toast>
